import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Skeleton from "@material-ui/lab/Skeleton";
import Typography from "@material-ui/core/Typography";

import { useStyles } from "./loadingCardStyle";

export default function LoadingCard() {
  const classes = useStyles();

  return (
    <Grid container spacing={0}>
      {[0, 1, 2, 3, 4].map((value) => (
        <Grid key={value} item>
          <Card className={classes.card} elevation={0} variant="outlined">
            <CardHeader
              avatar={<Skeleton variant="circle" width={40} height={40} />}
              subheader={<Skeleton variant="text" />}
            />

            <Skeleton variant="rect" animation="wave" width={265} height={75} />

            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                {<Skeleton />}
                {<Skeleton />}
                {<Skeleton />}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
